export enum AppointmentStatus {
  Scheduled = 0,
  CheckedIn = 1,
  InProgress = 2,
  Completed = 3,
  Cancelled = 4,
  NoShow = 5,
  WalkIn = 6,
  ScheduledByPublicWeb = 8,
}

export enum AppointmentServiceStatus {
  Pending = 0,
  Completed = 1,
  Cancelled = 2,
}

export interface Appointment {
  id: string;
  organizationId: string;
  branchId?: string | null;
  clientId: string;
  staffUserId?: string | null;
  staffName?: string | null;
  status: AppointmentStatus;
  scheduledAt: string;
  startAt?: string | null;
  endAt?: string | null;
  notes?: string | null;
  cancelReason?: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy?: string | null;
  updatedBy?: string | null;
  services: AppointmentServiceItem[];
  clientName?: string | null;
  clientPhone?: string | null;
  clientEmail?: string | null;
  clientAddress?: string | null;
  clientAge?: number | null;
}

export interface AppointmentServiceItem {
  id: string;
  appointmentId: string;
  serviceId: string;
  serviceName?: string | null;
  price: number;
  durationMinutes: number;
  quantity: number;
  status: AppointmentServiceStatus;
  createdAt: string;
}

export interface AppointmentServiceInput {
  serviceId: string;
  serviceName?: string;
  price: number;
  durationMinutes: number;
  quantity: number;
}

export interface CreateAppointmentRequest {
  appointment: CreateAppointmentPayload;
  services?: AppointmentServiceInput[];
}

export interface CreateAppointmentPayload {
  organizationId: string;
  branchId?: string;
  clientId: string;
  staffUserId?: string;
  staffName?: string;
  status: AppointmentStatus;
  scheduledAt: string;
  notes?: string;
}

export interface AppointmentUpdateModel {
  branchId?: string;
  staffUserId?: string;
  staffName?: string;
  status?: AppointmentStatus;
  scheduledAt?: string;
  startAt?: string;
  endAt?: string;
  notes?: string;
  cancelReason?: string;
  services?: AppointmentServiceInput[];
}